import ValidityHint from '@lib/enums/validityHint';
import styles from './TaskCompletionRows.module.scss';

export default function getTableRowClassNameByValidityHint(
  validityHint?: string | null,
) {
  if (validityHint === ValidityHint.Failure) {
    return styles.redRow;
  }
  if (validityHint === ValidityHint.Warning) {
    return styles.yellowRow;
  }
  return undefined;
}
